// TO DO: move it in env dependent variables

// export const apiUrl: string = 'http://192.168.1.11:8000'
// export const apiUrl: string = 'http://192.168.0.223:8000'
// export const apiUrl: string = 'http://192.168.0.133:8000'
// export const apiUrl: string = 'http://192.168.1.104:8000'
export const apiUrl: string = 'https://api.raiseareader.ro'
